import api from "./Api";

class AjudaService {
  GetAjuda(payload) {
    return api.get("/v1/ajuda/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAjuda(payload) {
    return api.post("/v1/ajuda/", payload).then((response) => {
      return response.data;
    });
  }

  PutAjuda(payload) {
    return api.put("/v1/ajuda/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAjuda(payload) {
    return api.delete("/v1/ajuda/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAjudaOData(payload) {
    return api.get("/OData/Ajuda" + payload).then((response) => {
      return response.data;
    });
  }

  PostAjudaUpload(payload) {
    return api.post("/v1/ajudaUpload/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAjudaUpload(payload) {
    return api.delete("/v1/ajudaUpload/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAjudasUsuario(payload) {
    return api.get("/v1/ajuda/GetAjudasUsuario").then((response) => {
      return response.data;
    });
  }
}

export default new AjudaService();
